import { FOOTNOTES_ITEM_LABEL_COLOR, PHONE_RESOLUTION } from 'src/styles/variables'
import styled from 'styled-components'


export const OVOFootnoteReferenceMarker = styled.sup``

export const OVOFootnoteFootnoteMarker = styled.span``

export const OVOFootnoteWrapper = styled.div`
  padding: 60px 0;
  @media screen and (max-width: ${PHONE_RESOLUTION}) {
    padding: 40px 0;
  }
`

export const OVOFootnoteContainer = styled.div<{ isFullWidth?: boolean }>`
  max-width: ${props => (props.isFullWidth ? '100%' : '870px')};
  margin: 0 auto;
`

export const OVOFootnoteTitle = styled.div`
  margin-bottom: 20px;
  @media screen and (max-width: ${PHONE_RESOLUTION}) {
    margin-bottom: 15px;
    h4 {
      font-size: 16px;
    }
  }
`

export const OVOFootnoteList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

export const OVOFootnoteListItem = styled.li`
  font-size: 16px;
  line-height: 2;
  margin-bottom: 10px;
  color: var(--footnotesItemContentColor);
  @media screen and (max-width: ${PHONE_RESOLUTION}) {
    font-size: 13px;
  }
  span {
    color: ${FOOTNOTES_ITEM_LABEL_COLOR};
    margin-right: 4px;
  }
`
